import { render, staticRenderFns } from "./PriceManagementOccupy.vue?vue&type=template&id=4ad572a0&"
import script from "./PriceManagementOccupy.vue?vue&type=script&lang=js&"
export * from "./PriceManagementOccupy.vue?vue&type=script&lang=js&"
import style0 from "./PriceManagementOccupy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports